export default "__VITE_ASSET__f606d170__"